import { Logo } from "@/components"
import { Burger } from "@/components/Icon/Burger"
import { useLayout } from "@/lib/preFetch/preFetchLayout"
import { useGate } from "@jog/react-components"
import { newHeaderEvent } from "@jog/shared"

import { DesktopNavMenu } from "./DesktopNavMenu"
import { MobileNav } from "./MobileNav"
import { NavInfo, Servers } from "./NavInfo"
import { NavSearch } from "./NavSearch"
import { Suggestions } from "./Suggestions"

export const HeaderNav = ({ isCartPage }: { isCartPage: boolean }) => {
    const layout = useLayout()
    const logo = layout?.layout?.logo
    const { menu } = newHeaderEvent()
    const { value: suggestions } = useGate("suggestions")
    return (
        <div className="w-full bg-white">
            <div className="mx-auto w-full max-w-full lg:max-w-[960px] xl:max-w-[1140px] 2xl:max-w-[1400px]">
                <div className="grid grid-cols-[auto,1fr,auto] grid-rows-[60px]">
                    <div className="col-start-1 row-start-1 flex items-center justify-center lg:hidden">
                        <MobileNav>
                            <Burger className="text-gray-icon" />
                        </MobileNav>
                    </div>
                    <div className="col-start-2 col-end-4 row-start-1 flex items-center justify-start pl-2 lg:col-start-1 lg:justify-center lg:pl-0">
                        <Logo
                            onClick={menu}
                            src={logo.url}
                            width={logo.dimensions.width}
                            height={logo.dimensions.height}
                            alt=""
                            aria-label="Homepage"
                        />
                    </div>
                    <div className="col-start-1 row-start-1 hidden lg:block">
                        <Servers />
                    </div>
                    <div className="col-end-4 row-start-1">
                        <NavInfo isCartPage={isCartPage} />
                    </div>
                </div>
                <div className="grid grid-cols-[1fr,auto,1fr] grid-rows-[40px]">
                    <div className="col-start-2 col-end-3 row-start-1 hidden lg:block">
                        <DesktopNavMenu />
                    </div>
                    <div className="col-start-1 col-end-4 row-start-1 lg:col-start-3">
                        {suggestions ? <Suggestions /> : <NavSearch />}
                    </div>
                </div>
            </div>
        </div>
    )
}
